import AppStore from "./AppStore";
import { buildClassName } from "./util";

// id: "35bb3f20-d401-4446-afde-8b005017c5d3"
// title: "Secondary Marketing Hero"
// type: :html
// key: "secondary-marketing-hero"
// parent_id: nil
export function SecondaryMarketingHero35bb3f20D4014446Afde8b005017c5d3(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHero35bb3f20D4014446Afde8b005017c5d3 hero`}>
      <h1 className="title">
        {props["title"] || Title9f636c1d2a3c44f4Be8696e625d60671}
      </h1>
    </div>
  );
}

// id: "89d482b3-2d0d-4d83-bbd5-c614a894a1bc"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "a1bbb381-43d6-456e-b618-166de9ce9fb5"
export function Groupflow89d482b32d0d4d83Bbd5C614a894a1bc(props: any) {
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="Groupflow89d482b32d0d4d83Bbd5C614a894a1bc" parentTag={buildClassName("Groupflow89d482b32d0d4d83Bbd5C614a894a1bc", parentTag)} {...props} />
  );
}

// id: "fbf7f4a6-ff5e-40bc-a4d8-6f0a67ee0052"
// title: ""
// type: :html
// key: "hero-wrapper"
// parent_id: "6326ab60-9656-4cb5-b3cc-9ad5600b17c6"
export function HeroWrapperFbf7f4a6Ff5e40bcA4d86f0a67ee0052(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HeroWrapperFbf7f4a6Ff5e40bcA4d86f0a67ee0052`}>
      {props["hero"] || <Hero className="Hero6ad87e0e7607467eAe83Ba0691cbd884" parentTag={buildClassName("Hero6ad87e0e7607467eAe83Ba0691cbd884", parentTag)} postSlug="home-hero" {...props} />}
    </div>
  );
}

// id: "6ad87e0e-7607-467e-ae83-ba0691cbd884"
// title: ""
// type: :gf_preset
// key: "hero"
// parent_id: "fbf7f4a6-ff5e-40bc-a4d8-6f0a67ee0052"
export function Hero6ad87e0e7607467eAe83Ba0691cbd884(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Hero className="Hero6ad87e0e7607467eAe83Ba0691cbd884" parentTag={buildClassName("Hero6ad87e0e7607467eAe83Ba0691cbd884", parentTag)} postSlug="home-hero" {...props} />
  );
}

// id: "22e87ea4-d6fa-4247-a1e8-cc5ff30f395a"
// title: "Public Events Page"
// type: :html
// key: "public-events-page"
// parent_id: nil
export function PublicEventsPage22e87ea4D6fa4247A1e8Cc5ff30f395a(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PublicEventsPage22e87ea4D6fa4247A1e8Cc5ff30f395a`}>
      {props["header"] || <SecondaryMarketingHeader1569cffa972b42d5B3548818ba66d3cb parentTag="HeaderA0a17cd9C342498bB78f84f324c77e77" title="Public Events" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooterA1bbb38143d6456eB618166de9ce9fb5 parentTag="Footer47a4dd3885914677Ad68365ba141b9b1" {...props} />}
    </div>
  );
}

// id: "39d89c27-0b30-4976-b6e1-7b2ce578fdce"
// title: ""
// type: :html
// key: "main"
// parent_id: "b4f0272b-5899-42fd-9c71-48ce6a06e820"
export function Main39d89c270b304976B6e17b2ce578fdce(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <main className={`${parentTag || ""} Main39d89c270b304976B6e17b2ce578fdce`}>
      <div className="cards-wrapper">
        {props["cards"] || <MarketingCards className="Cards0cf74847F9b34b9eAeb2F3ef42c7942f" parentTag={buildClassName("Cards0cf74847F9b34b9eAeb2F3ef42c7942f", parentTag)} postSlug="about-us-cards" {...props} />}
      </div>
    </main>
  );
}

// id: "881442bc-6cb3-494f-8384-debeaa6f7cac"
// title: ""
// type: :text
// key: "title"
// parent_id: "1b209244-5b66-45af-9f88-22ea905adfef"
export const Title881442bc6cb3494f8384Debeaa6f7cac = "Join Us";

// id: "3cb3b6c1-bdb2-4325-ac6f-8b870c1e67ae"
// title: ""
// type: :text
// key: "buttonClass"
// parent_id: "68f011ee-dfa9-44a5-8a35-b1484b39e661"
export const ButtonClass3cb3b6c1Bdb24325Ac6f8b870c1e67ae = "inline-block px-12 py-3 hover:brightness-110 transition duration";

// id: "1569cffa-972b-42d5-b354-8818ba66d3cb"
// title: "Secondary Marketing Header"
// type: :html
// key: "secondary-marketing-header"
// parent_id: nil
export function SecondaryMarketingHeader1569cffa972b42d5B3548818ba66d3cb(props: any) {
  const { parentTag, ...rest } = props;
  props = { title: "Secondary Marketing Title 1", ...rest };
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHeader1569cffa972b42d5B3548818ba66d3cb site-header`}>
      <div className="background-image" />
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTopE7e71efb5aed4a33Bb767016e1c5dc9f parentTag="HeaderTop6e4f0fc2E52c4904A01370886b24839f" {...props} />}
      </div>
      {props["hero"] || <SecondaryMarketingHero35bb3f20D4014446Afde8b005017c5d3 parentTag="HeroDfa59db3C0be418599b4194f167f84ee" title="Secondary Marketing Title 2" {...props} />}
    </div>
  );
}

// id: "246b20cb-0c3b-47dc-beea-24641e92be7a"
// title: ""
// type: :reference
// key: "header"
// parent_id: "b4f0272b-5899-42fd-9c71-48ce6a06e820"
export function Header246b20cb0c3b47dcBeea24641e92be7a(props: any) {
  return (
    <SecondaryMarketingHeader1569cffa972b42d5B3548818ba66d3cb parentTag="Header246b20cb0c3b47dcBeea24641e92be7a" title="About Us" {...props} />
  );
}

// id: "90c7abf9-dbca-48ba-ad64-e29b885dbc01"
// title: ""
// type: :text
// key: "title"
// parent_id: "f85c704d-6153-4e94-bce7-7e05630148d8"
export const Title90c7abf9Dbca48baAd64E29b885dbc01 = "Secondary Page";

// id: "87078f38-5bdb-4239-bc42-8e7d5748547f"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "6ad87e0e-7607-467e-ae83-ba0691cbd884"
export const PostSlug87078f385bdb4239Bc428e7d5748547f = "home-hero";

// id: "1134f108-346c-4fa4-865e-8e719b820dba"
// title: "Member Application Pages"
// type: :reference
// key: "application-pages"
// parent_id: nil
export function ApplicationPages1134f108346c4fa4865e8e719b820dba(props: any) {
  return (
    <SecondaryPage7695efca017e433cB2873ec3e74ce08b parentTag="ApplicationPages1134f108346c4fa4865e8e719b820dba" header={<SecondaryMarketingHeader1569cffa972b42d5B3548818ba66d3cb parentTag="HeaderB13dbad4Ffbf41ab933096c70f94d1fa" title="Join Us" />} {...props} />
  );
}

// id: "81b3d786-b88a-4aa3-a9a9-fbbbcfa3c312"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "e7e71efb-5aed-4a33-bb76-7016e1c5dc9f"
export function Logo81b3d786B88a4aa3A9a9Fbbbcfa3c312(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="Logo81b3d786B88a4aa3A9a9Fbbbcfa3c312" parentTag={buildClassName("Logo81b3d786B88a4aa3A9a9Fbbbcfa3c312", parentTag)} logoType="DEFAULT" {...props} />
  );
}

// id: "e8744b6d-e58c-4381-a678-286136cf8f0e"
// title: ""
// type: :text
// key: "title"
// parent_id: "dfa59db3-c0be-4185-99b4-194f167f84ee"
export const TitleE8744b6dE58c4381A678286136cf8f0e = "Secondary Marketing Title 2";

// id: "a1bbb381-43d6-456e-b618-166de9ce9fb5"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooterA1bbb38143d6456eB618166de9ce9fb5(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const Logo = AppStore.presets["Logo"];
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <footer className={`${parentTag || ""} DefaultFooterA1bbb38143d6456eB618166de9ce9fb5 footer`}>
      {props["links"] || <Navigation className="Links04c1cb123e5848cbB4d93cb33f968173" parentTag={buildClassName("Links04c1cb123e5848cbB4d93cb33f968173", parentTag)} navMenuSlug="footer-nav" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <Logo className="Logo2b16e8428bbb49629263410e7ffaa224" parentTag={buildClassName("Logo2b16e8428bbb49629263410e7ffaa224", parentTag)} contentSlug="footer-logo" logoType="FOOTER" {...props} />}
      </div>
      {props["copyright"] || <GroupCopyright className="Copyright5871f6dcBfb846e3924aA4fa516cd61a" parentTag={buildClassName("Copyright5871f6dcBfb846e3924aA4fa516cd61a", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="Groupflow89d482b32d0d4d83Bbd5C614a894a1bc" parentTag={buildClassName("Groupflow89d482b32d0d4d83Bbd5C614a894a1bc", parentTag)} {...props} />}
    </footer>
  );
}

// id: "b13dbad4-ffbf-41ab-9330-96c70f94d1fa"
// title: ""
// type: :reference
// key: "header"
// parent_id: "1134f108-346c-4fa4-865e-8e719b820dba"
export function HeaderB13dbad4Ffbf41ab933096c70f94d1fa(props: any) {
  return (
    <SecondaryMarketingHeader1569cffa972b42d5B3548818ba66d3cb parentTag="HeaderB13dbad4Ffbf41ab933096c70f94d1fa" title="Join Us" {...props} />
  );
}

// id: "0cf74847-f9b3-4b9e-aeb2-f3ef42c7942f"
// title: ""
// type: :gf_preset
// key: "cards"
// parent_id: "39d89c27-0b30-4976-b6e1-7b2ce578fdce"
export function Cards0cf74847F9b34b9eAeb2F3ef42c7942f(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="Cards0cf74847F9b34b9eAeb2F3ef42c7942f" parentTag={buildClassName("Cards0cf74847F9b34b9eAeb2F3ef42c7942f", parentTag)} postSlug="about-us-cards" {...props} />
  );
}

// id: "e7e71efb-5aed-4a33-bb76-7016e1c5dc9f"
// title: "Header Area Top"
// type: :html
// key: "default-header-top"
// parent_id: nil
export function DefaultHeaderTopE7e71efb5aed4a33Bb767016e1c5dc9f(props: any) {
  const Link = AppStore.presets["Link"];
  const Logo = AppStore.presets["Logo"];
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} DefaultHeaderTopE7e71efb5aed4a33Bb767016e1c5dc9f header-top`}>
      {props["linked-logo"] || <Link className="LinkedLogo0536eca39fb34d6aA2e3562249760159" parentTag={buildClassName("LinkedLogo0536eca39fb34d6aA2e3562249760159", parentTag)} className="linked-logo" label={<Logo className="LabelC052886e5dc144de9dc099fbb5657aaf" parentTag={buildClassName("LabelC052886e5dc144de9dc099fbb5657aaf", parentTag)} logoType="DEFAULT" contentSlug="header-logo" {...props} />} url="/" {...props} />}
      {props["navigation"] || <PrimaryNavigation className="Navigation983ebcb7A58b4bb696d911863cd06bb3" parentTag={buildClassName("Navigation983ebcb7A58b4bb696d911863cd06bb3", parentTag)} navMenuSlug="marketing-primary-nav" className="navigation" {...props} />}
    </div>
  );
}

// id: "94809232-6177-4c08-bdd7-75aaa0943123"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "7695efca-017e-433c-b287-3ec3e74ce08b"
export function Footer9480923261774c08Bdd775aaa0943123(props: any) {
  return (
    <DefaultFooterA1bbb38143d6456eB618166de9ce9fb5 parentTag="Footer9480923261774c08Bdd775aaa0943123" {...props} />
  );
}

// id: "a01be10b-dfab-498f-9764-9cd616fc3fce"
// title: ""
// type: :text
// key: "title"
// parent_id: "b13dbad4-ffbf-41ab-9330-96c70f94d1fa"
export const TitleA01be10bDfab498f97649cd616fc3fce = "Join Us";

// id: "69f816e4-c103-4909-81e2-2afc3bf84b93"
// title: "Home Page"
// type: :html
// key: "home-page"
// parent_id: nil
export function HomePage69f816e4C103490981e22afc3bf84b93(props: any) {
  const Header = AppStore.presets["Header"];
  const WelcomeBackPopUp = AppStore.presets["WelcomeBackPopUp"];
  const MarketingCards = AppStore.presets["MarketingCards"];
  const PageQuote = AppStore.presets["PageQuote"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomePage69f816e4C103490981e22afc3bf84b93 gf-page-layout`}>
      {props["header-wrapper"] || <HeaderWrapper6326ab6096564cb5B3cc9ad5600b17c6 />}
      {props["welcome-back"] || <WelcomeBackPopUp className="WelcomeBack58fcb34f2c59447391d93c6248eb4d4a" parentTag={buildClassName("WelcomeBack58fcb34f2c59447391d93c6248eb4d4a", parentTag)} {...props} />}
      {props["main"] || <Main3e0e0c2541614d99A6c7Ff4762467eb8 />}
      {props["quote"] || <PageQuote className="QuoteBd06971c294640b2B388Ba5481af6f88" parentTag={buildClassName("QuoteBd06971c294640b2B388Ba5481af6f88", parentTag)} contentSlug="home-page-quote" {...props} />}
      {props["footer"] || <DefaultFooterA1bbb38143d6456eB618166de9ce9fb5 parentTag="Footer47867ba0945f4708Bb450f431b92e1c3" {...props} />}
    </div>
  );
}

// id: "3e0e0c25-4161-4d99-a6c7-ff4762467eb8"
// title: "Home Main"
// type: :html
// key: "main"
// parent_id: "69f816e4-c103-4909-81e2-2afc3bf84b93"
export function Main3e0e0c2541614d99A6c7Ff4762467eb8(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <main className={`${parentTag || ""} Main3e0e0c2541614d99A6c7Ff4762467eb8`}>
      <div className="cards-wrapper">
        {props["cards"] || <MarketingCards className="Cards68f011eeDfa944a58a35B1484b39e661" parentTag={buildClassName("Cards68f011eeDfa944a58a35B1484b39e661", parentTag)} buttonClass="inline-block px-12 py-3 hover:brightness-110 transition duration" postSlug="home-page-cards" {...props} />}
      </div>
    </main>
  );
}

// id: "2872879d-1fcf-4e83-afc3-7bd6620b7dbf"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "bd06971c-2946-40b2-b388-ba5481af6f88"
export const ContentSlug2872879d1fcf4e83Afc37bd6620b7dbf = "home-page-quote";

// id: "7695efca-017e-433c-b287-3ec3e74ce08b"
// title: "Secondary Page"
// type: :html
// key: "secondary-page"
// parent_id: nil
export function SecondaryPage7695efca017e433cB2873ec3e74ce08b(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryPage7695efca017e433cB2873ec3e74ce08b`}>
      {props["header"] || <SecondaryMarketingHeader1569cffa972b42d5B3548818ba66d3cb parentTag="HeaderF85c704d61534e94Bce77e05630148d8" title="Secondary Page" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooterA1bbb38143d6456eB618166de9ce9fb5 parentTag="Footer9480923261774c08Bdd775aaa0943123" {...props} />}
    </div>
  );
}

// id: "68464815-e8dd-4656-81ea-92fc9114edb4"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "b4f0272b-5899-42fd-9c71-48ce6a06e820"
export function Footer68464815E8dd465681ea92fc9114edb4(props: any) {
  return (
    <DefaultFooterA1bbb38143d6456eB618166de9ce9fb5 parentTag="Footer68464815E8dd465681ea92fc9114edb4" {...props} />
  );
}

// id: "014230c7-d712-4d07-88b3-ea21e9e50c4b"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "04c1cb12-3e58-48cb-b4d9-3cb33f968173"
export const NavMenuSlug014230c7D7124d0788b3Ea21e9e50c4b = "footer-nav";

// id: "29bfcd8e-6078-448b-9607-cec19b1c4844"
// title: "Join Us Page"
// type: :reference
// key: "join-us-page"
// parent_id: nil
export function JoinUsPage29bfcd8e6078448b9607Cec19b1c4844(props: any) {
  return (
    <SecondaryPage7695efca017e433cB2873ec3e74ce08b parentTag="JoinUsPage29bfcd8e6078448b9607Cec19b1c4844" header={<SecondaryMarketingHeader1569cffa972b42d5B3548818ba66d3cb parentTag="Header1b2092445b6645af9f8822ea905adfef" title="Join Us" />} {...props} />
  );
}

// id: "0536eca3-9fb3-4d6a-a2e3-562249760159"
// title: ""
// type: :gf_preset
// key: "linked-logo"
// parent_id: "e7e71efb-5aed-4a33-bb76-7016e1c5dc9f"
export function LinkedLogo0536eca39fb34d6aA2e3562249760159(props: any) {
  const Link = AppStore.presets["Link"];
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Link className="LinkedLogo0536eca39fb34d6aA2e3562249760159" parentTag={buildClassName("LinkedLogo0536eca39fb34d6aA2e3562249760159", parentTag)} className="linked-logo" label={<Logo className="LabelC052886e5dc144de9dc099fbb5657aaf" parentTag={buildClassName("LabelC052886e5dc144de9dc099fbb5657aaf", parentTag)} logoType="DEFAULT" contentSlug="header-logo" {...props} />} url="/" {...props} />
  );
}

// id: "98259503-5e4b-4d86-b726-b4c780911443"
// title: ""
// type: :text
// key: "class"
// parent_id: "0536eca3-9fb3-4d6a-a2e3-562249760159"
export const Class982595035e4b4d86B726B4c780911443 = "linked-logo";

// id: "b4f0272b-5899-42fd-9c71-48ce6a06e820"
// title: "About Us"
// type: :html
// key: "about-us-page"
// parent_id: nil
export function AboutUsPageB4f0272b589942fd9c7148ce6a06e820(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AboutUsPageB4f0272b589942fd9c7148ce6a06e820 gf-page-layout`}>
      {props["header"] || <SecondaryMarketingHeader1569cffa972b42d5B3548818ba66d3cb parentTag="Header246b20cb0c3b47dcBeea24641e92be7a" title="About Us" {...props} />}
      {props["main"] || <Main39d89c270b304976B6e17b2ce578fdce />}
      {props["footer"] || <DefaultFooterA1bbb38143d6456eB618166de9ce9fb5 parentTag="Footer68464815E8dd465681ea92fc9114edb4" {...props} />}
    </div>
  );
}

// id: "04c1cb12-3e58-48cb-b4d9-3cb33f968173"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "a1bbb381-43d6-456e-b618-166de9ce9fb5"
export function Links04c1cb123e5848cbB4d93cb33f968173(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="Links04c1cb123e5848cbB4d93cb33f968173" parentTag={buildClassName("Links04c1cb123e5848cbB4d93cb33f968173", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "68f011ee-dfa9-44a5-8a35-b1484b39e661"
// title: "Home Cards"
// type: :gf_preset
// key: "cards"
// parent_id: "3e0e0c25-4161-4d99-a6c7-ff4762467eb8"
export function Cards68f011eeDfa944a58a35B1484b39e661(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="Cards68f011eeDfa944a58a35B1484b39e661" parentTag={buildClassName("Cards68f011eeDfa944a58a35B1484b39e661", parentTag)} buttonClass="inline-block px-12 py-3 hover:brightness-110 transition duration" postSlug="home-page-cards" {...props} />
  );
}

// id: "9f636c1d-2a3c-44f4-be86-96e625d60671"
// title: ""
// type: :text
// key: "title"
// parent_id: "35bb3f20-d401-4446-afde-8b005017c5d3"
export const Title9f636c1d2a3c44f4Be8696e625d60671 = "Default Title";

// id: "c052886e-5dc1-44de-9dc0-99fbb5657aaf"
// title: "Home Page Logo"
// type: :gf_preset
// key: "label"
// parent_id: "0536eca3-9fb3-4d6a-a2e3-562249760159"
export function LabelC052886e5dc144de9dc099fbb5657aaf(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="LabelC052886e5dc144de9dc099fbb5657aaf" parentTag={buildClassName("LabelC052886e5dc144de9dc099fbb5657aaf", parentTag)} logoType="DEFAULT" contentSlug="header-logo" {...props} />
  );
}

// id: "f85c704d-6153-4e94-bce7-7e05630148d8"
// title: ""
// type: :reference
// key: "header"
// parent_id: "7695efca-017e-433c-b287-3ec3e74ce08b"
export function HeaderF85c704d61534e94Bce77e05630148d8(props: any) {
  return (
    <SecondaryMarketingHeader1569cffa972b42d5B3548818ba66d3cb parentTag="HeaderF85c704d61534e94Bce77e05630148d8" title="Secondary Page" {...props} />
  );
}

// id: "a0a17cd9-c342-498b-b78f-84f324c77e77"
// title: ""
// type: :reference
// key: "header"
// parent_id: "22e87ea4-d6fa-4247-a1e8-cc5ff30f395a"
export function HeaderA0a17cd9C342498bB78f84f324c77e77(props: any) {
  return (
    <SecondaryMarketingHeader1569cffa972b42d5B3548818ba66d3cb parentTag="HeaderA0a17cd9C342498bB78f84f324c77e77" title="Public Events" {...props} />
  );
}

// id: "d176e4db-4450-4d17-87d1-abc72c9587bb"
// title: ""
// type: :text
// key: "title"
// parent_id: "a0a17cd9-c342-498b-b78f-84f324c77e77"
export const TitleD176e4db44504d1787d1Abc72c9587bb = "Public Events";

// id: "2b16e842-8bbb-4962-9263-410e7ffaa224"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "a1bbb381-43d6-456e-b618-166de9ce9fb5"
export function Logo2b16e8428bbb49629263410e7ffaa224(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="Logo2b16e8428bbb49629263410e7ffaa224" parentTag={buildClassName("Logo2b16e8428bbb49629263410e7ffaa224", parentTag)} contentSlug="footer-logo" logoType="FOOTER" {...props} />
  );
}

// id: "47867ba0-945f-4708-bb45-0f431b92e1c3"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "69f816e4-c103-4909-81e2-2afc3bf84b93"
export function Footer47867ba0945f4708Bb450f431b92e1c3(props: any) {
  return (
    <DefaultFooterA1bbb38143d6456eB618166de9ce9fb5 parentTag="Footer47867ba0945f4708Bb450f431b92e1c3" {...props} />
  );
}

// id: "da7ab70d-5a4d-4e46-9784-81f2c719714f"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "983ebcb7-a58b-4bb6-96d9-11863cd06bb3"
export const NavMenuSlugDa7ab70d5a4d4e46978481f2c719714f = "marketing-primary-nav";

// id: "1b209244-5b66-45af-9f88-22ea905adfef"
// title: ""
// type: :reference
// key: "header"
// parent_id: "29bfcd8e-6078-448b-9607-cec19b1c4844"
export function Header1b2092445b6645af9f8822ea905adfef(props: any) {
  return (
    <SecondaryMarketingHeader1569cffa972b42d5B3548818ba66d3cb parentTag="Header1b2092445b6645af9f8822ea905adfef" title="Join Us" {...props} />
  );
}

// id: "6e4f0fc2-e52c-4904-a013-70886b24839f"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "1569cffa-972b-42d5-b354-8818ba66d3cb"
export function HeaderTop6e4f0fc2E52c4904A01370886b24839f(props: any) {
  return (
    <DefaultHeaderTopE7e71efb5aed4a33Bb767016e1c5dc9f parentTag="HeaderTop6e4f0fc2E52c4904A01370886b24839f" {...props} />
  );
}

// id: "e0947801-d8f0-4a1f-a015-a342f50da124"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "2b16e842-8bbb-4962-9263-410e7ffaa224"
export const ContentSlugE0947801D8f04a1fA015A342f50da124 = "footer-logo";

// id: "bd06971c-2946-40b2-b388-ba5481af6f88"
// title: ""
// type: :gf_preset
// key: "quote"
// parent_id: "69f816e4-c103-4909-81e2-2afc3bf84b93"
export function QuoteBd06971c294640b2B388Ba5481af6f88(props: any) {
  const PageQuote = AppStore.presets["PageQuote"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageQuote className="QuoteBd06971c294640b2B388Ba5481af6f88" parentTag={buildClassName("QuoteBd06971c294640b2B388Ba5481af6f88", parentTag)} contentSlug="home-page-quote" {...props} />
  );
}

// id: "983ebcb7-a58b-4bb6-96d9-11863cd06bb3"
// title: ""
// type: :gf_preset
// key: "navigation"
// parent_id: "e7e71efb-5aed-4a33-bb76-7016e1c5dc9f"
export function Navigation983ebcb7A58b4bb696d911863cd06bb3(props: any) {
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PrimaryNavigation className="Navigation983ebcb7A58b4bb696d911863cd06bb3" parentTag={buildClassName("Navigation983ebcb7A58b4bb696d911863cd06bb3", parentTag)} navMenuSlug="marketing-primary-nav" className="navigation" {...props} />
  );
}

// id: "20284d7d-e1dd-411e-b42c-9eca676c3c57"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "6326ab60-9656-4cb5-b3cc-9ad5600b17c6"
export function HeaderTop20284d7dE1dd411eB42c9eca676c3c57(props: any) {
  return (
    <DefaultHeaderTopE7e71efb5aed4a33Bb767016e1c5dc9f parentTag="HeaderTop20284d7dE1dd411eB42c9eca676c3c57" {...props} />
  );
}

// id: "58fcb34f-2c59-4473-91d9-3c6248eb4d4a"
// title: ""
// type: :gf_preset
// key: "welcome-back"
// parent_id: "69f816e4-c103-4909-81e2-2afc3bf84b93"
export function WelcomeBack58fcb34f2c59447391d93c6248eb4d4a(props: any) {
  const WelcomeBackPopUp = AppStore.presets["WelcomeBackPopUp"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <WelcomeBackPopUp className="WelcomeBack58fcb34f2c59447391d93c6248eb4d4a" parentTag={buildClassName("WelcomeBack58fcb34f2c59447391d93c6248eb4d4a", parentTag)} {...props} />
  );
}

// id: "5871f6dc-bfb8-46e3-924a-a4fa516cd61a"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "a1bbb381-43d6-456e-b618-166de9ce9fb5"
export function Copyright5871f6dcBfb846e3924aA4fa516cd61a(props: any) {
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="Copyright5871f6dcBfb846e3924aA4fa516cd61a" parentTag={buildClassName("Copyright5871f6dcBfb846e3924aA4fa516cd61a", parentTag)} {...props} />
  );
}

// id: "ffb3a8a9-c1fa-4ffb-a4b3-e97822cc9ebb"
// title: ""
// type: :text
// key: "title"
// parent_id: "246b20cb-0c3b-47dc-beea-24641e92be7a"
export const TitleFfb3a8a9C1fa4ffbA4b3E97822cc9ebb = "About Us";

// id: "dfa59db3-c0be-4185-99b4-194f167f84ee"
// title: ""
// type: :reference
// key: "hero"
// parent_id: "1569cffa-972b-42d5-b354-8818ba66d3cb"
export function HeroDfa59db3C0be418599b4194f167f84ee(props: any) {
  return (
    <SecondaryMarketingHero35bb3f20D4014446Afde8b005017c5d3 parentTag="HeroDfa59db3C0be418599b4194f167f84ee" title="Secondary Marketing Title 2" {...props} />
  );
}

// id: "61d31c83-acec-41e6-be6d-eb100bdb9224"
// title: ""
// type: :text
// key: "class"
// parent_id: "983ebcb7-a58b-4bb6-96d9-11863cd06bb3"
export const Class61d31c83Acec41e6Be6dEb100bdb9224 = "navigation";

// id: "49e7cf5d-30a7-4832-853d-69cb52f454af"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "68f011ee-dfa9-44a5-8a35-b1484b39e661"
export const PostSlug49e7cf5d30a74832853d69cb52f454af = "home-page-cards";

// id: "47a4dd38-8591-4677-ad68-365ba141b9b1"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "22e87ea4-d6fa-4247-a1e8-cc5ff30f395a"
export function Footer47a4dd3885914677Ad68365ba141b9b1(props: any) {
  return (
    <DefaultFooterA1bbb38143d6456eB618166de9ce9fb5 parentTag="Footer47a4dd3885914677Ad68365ba141b9b1" {...props} />
  );
}

// id: "78408b94-554f-467f-8642-0bb814970401"
// title: ""
// type: :text
// key: "url"
// parent_id: "0536eca3-9fb3-4d6a-a2e3-562249760159"
export const Url78408b94554f467f86420bb814970401 = "/";

// id: "c55ced24-f2a7-4946-a572-8c91b7e63777"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "c052886e-5dc1-44de-9dc0-99fbb5657aaf"
export const LogoTypeC55ced24F2a74946A5728c91b7e63777 = "DEFAULT";

// id: "07716aef-5a5d-4c55-9c95-0fba6742ef09"
// title: ""
// type: :text
// key: "title"
// parent_id: "1569cffa-972b-42d5-b354-8818ba66d3cb"
export const Title07716aef5a5d4c559c950fba6742ef09 = "Secondary Marketing Title 1";

// id: "0c2ed084-79b3-4679-b3be-e487dd6565c2"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "81b3d786-b88a-4aa3-a9a9-fbbbcfa3c312"
export const LogoType0c2ed08479b34679B3beE487dd6565c2 = "DEFAULT";

// id: "70abbcd3-0376-4843-a5b8-78cb60aa465c"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "0cf74847-f9b3-4b9e-aeb2-f3ef42c7942f"
export const PostSlug70abbcd303764843A5b878cb60aa465c = "about-us-cards";

// id: "6326ab60-9656-4cb5-b3cc-9ad5600b17c6"
// title: "Home Header Wrapper"
// type: :html
// key: "header-wrapper"
// parent_id: "69f816e4-c103-4909-81e2-2afc3bf84b93"
export function HeaderWrapper6326ab6096564cb5B3cc9ad5600b17c6(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HeaderWrapper6326ab6096564cb5B3cc9ad5600b17c6`}>
      <div className="background-image" />
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTopE7e71efb5aed4a33Bb767016e1c5dc9f parentTag="HeaderTop20284d7dE1dd411eB42c9eca676c3c57" {...props} />}
      </div>
      {props["hero-wrapper"] || <HeroWrapperFbf7f4a6Ff5e40bcA4d86f0a67ee0052 />}
    </div>
  );
}

// id: "3e2ef741-b365-451d-9727-37fab717cc4c"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "2b16e842-8bbb-4962-9263-410e7ffaa224"
export const LogoType3e2ef741B365451d972737fab717cc4c = "FOOTER";

// id: "b2211b7a-a6d5-4ebe-a045-4182e4b977c0"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "c052886e-5dc1-44de-9dc0-99fbb5657aaf"
export const ContentSlugB2211b7aA6d54ebeA0454182e4b977c0 = "header-logo";

const Components = {
  SecondaryMarketingHero35bb3f20D4014446Afde8b005017c5d3,
  Groupflow89d482b32d0d4d83Bbd5C614a894a1bc,
  HeroWrapperFbf7f4a6Ff5e40bcA4d86f0a67ee0052,
  Hero6ad87e0e7607467eAe83Ba0691cbd884,
  PublicEventsPage22e87ea4D6fa4247A1e8Cc5ff30f395a,
  Main39d89c270b304976B6e17b2ce578fdce,
  Title881442bc6cb3494f8384Debeaa6f7cac,
  ButtonClass3cb3b6c1Bdb24325Ac6f8b870c1e67ae,
  SecondaryMarketingHeader1569cffa972b42d5B3548818ba66d3cb,
  Header246b20cb0c3b47dcBeea24641e92be7a,
  Title90c7abf9Dbca48baAd64E29b885dbc01,
  PostSlug87078f385bdb4239Bc428e7d5748547f,
  ApplicationPages1134f108346c4fa4865e8e719b820dba,
  Logo81b3d786B88a4aa3A9a9Fbbbcfa3c312,
  TitleE8744b6dE58c4381A678286136cf8f0e,
  DefaultFooterA1bbb38143d6456eB618166de9ce9fb5,
  HeaderB13dbad4Ffbf41ab933096c70f94d1fa,
  Cards0cf74847F9b34b9eAeb2F3ef42c7942f,
  DefaultHeaderTopE7e71efb5aed4a33Bb767016e1c5dc9f,
  Footer9480923261774c08Bdd775aaa0943123,
  TitleA01be10bDfab498f97649cd616fc3fce,
  HomePage69f816e4C103490981e22afc3bf84b93,
  Main3e0e0c2541614d99A6c7Ff4762467eb8,
  ContentSlug2872879d1fcf4e83Afc37bd6620b7dbf,
  SecondaryPage7695efca017e433cB2873ec3e74ce08b,
  Footer68464815E8dd465681ea92fc9114edb4,
  NavMenuSlug014230c7D7124d0788b3Ea21e9e50c4b,
  JoinUsPage29bfcd8e6078448b9607Cec19b1c4844,
  LinkedLogo0536eca39fb34d6aA2e3562249760159,
  Class982595035e4b4d86B726B4c780911443,
  AboutUsPageB4f0272b589942fd9c7148ce6a06e820,
  Links04c1cb123e5848cbB4d93cb33f968173,
  Cards68f011eeDfa944a58a35B1484b39e661,
  Title9f636c1d2a3c44f4Be8696e625d60671,
  LabelC052886e5dc144de9dc099fbb5657aaf,
  HeaderF85c704d61534e94Bce77e05630148d8,
  HeaderA0a17cd9C342498bB78f84f324c77e77,
  TitleD176e4db44504d1787d1Abc72c9587bb,
  Logo2b16e8428bbb49629263410e7ffaa224,
  Footer47867ba0945f4708Bb450f431b92e1c3,
  NavMenuSlugDa7ab70d5a4d4e46978481f2c719714f,
  Header1b2092445b6645af9f8822ea905adfef,
  HeaderTop6e4f0fc2E52c4904A01370886b24839f,
  ContentSlugE0947801D8f04a1fA015A342f50da124,
  QuoteBd06971c294640b2B388Ba5481af6f88,
  Navigation983ebcb7A58b4bb696d911863cd06bb3,
  HeaderTop20284d7dE1dd411eB42c9eca676c3c57,
  WelcomeBack58fcb34f2c59447391d93c6248eb4d4a,
  Copyright5871f6dcBfb846e3924aA4fa516cd61a,
  TitleFfb3a8a9C1fa4ffbA4b3E97822cc9ebb,
  HeroDfa59db3C0be418599b4194f167f84ee,
  Class61d31c83Acec41e6Be6dEb100bdb9224,
  PostSlug49e7cf5d30a74832853d69cb52f454af,
  Footer47a4dd3885914677Ad68365ba141b9b1,
  Url78408b94554f467f86420bb814970401,
  LogoTypeC55ced24F2a74946A5728c91b7e63777,
  Title07716aef5a5d4c559c950fba6742ef09,
  LogoType0c2ed08479b34679B3beE487dd6565c2,
  PostSlug70abbcd303764843A5b878cb60aa465c,
  HeaderWrapper6326ab6096564cb5B3cc9ad5600b17c6,
  LogoType3e2ef741B365451d972737fab717cc4c,
  ContentSlugB2211b7aA6d54ebeA0454182e4b977c0
}

export default Components;